import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { PaginationBox } from './BasicTableStyled';
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from '@mui/material/Typography';
import Pagination from '@mui/material/Pagination';
const BasicTable = ({ rows, headerCells }) => {
    const [page, setPage] = React.useState(1);
    const [rowsPerPage, setRowsPerPage] = React.useState(15);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState("countryName");
    const createSortHandler = (property) => (event) => {
        setOrder(order == 'asc' ? 'desc' : 'asc');
        setOrderBy(property);
    };
    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) {
                return order;
            }
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

    return (
        <div>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead sx={{ borderBottom: "2px solid #1B4A83" }}>
                        <TableRow>
                            {headerCells.map((cell) => (
                                <TableCell key={cell.id}>{cell.label}
                                { (cell.id==='countryName' || cell.id==='headcount' )
                                && <TableSortLabel
                                            active={orderBy === cell.id}
                                            direction={orderBy === cell.id ? order : 'asc'}
                                            onClick={createSortHandler(cell.id)}>
                                        </TableSortLabel>}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

                    <TableBody sx={{ border: "1px solid #1B4A83" }}>
                        {(rowsPerPage > 0 ? stableSort(rows, getComparator(order, orderBy)).slice(
                            (Number(page) - 1) * rowsPerPage,
                            (Number(page) - 1) * rowsPerPage + rowsPerPage,) : rows)
                            .map((row, index) => (
                                <TableRow key={index}>
                                    {headerCells.map((cell) => (
                                        <TableCell key={cell.id} align="right">
                                            {isNaN(row[cell.id])?row[cell.id]:row[cell.id].toLocaleString()}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}

                    </TableBody>
                </Table>

            </TableContainer>
            <PaginationBox>
                <Typography variant='h6'>{rows.length}<span>Total Results</span></Typography>
                <Pagination
                    count={Math.ceil(rows.length / rowsPerPage)}
                    page={page}
                    onChange={handleChangePage} // Use onChange for page changes
                // Use onRowsPerPageChange for rows per page changes
                />
            </PaginationBox>




            {/* <PaginationBox>
                <Typography variant='h6'>{rowsPerPage}<span>Total Results</span></Typography>
                <Pagination
                   rowsPerPageOptions={[5, 10, 25]}
                   component="div"
                   count={rows.length}
                   rowsPerPage={rowsPerPage}
                   page={page}
                   onPageChange={handleChangePage}
                   onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </PaginationBox>             */}
        </div>
    );
}

export default BasicTable;
